import React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

const styles = {
  icon: {
    marginRight: "theme.spacing(2)",
  },
  mainContent: {
    backgroundColor: "theme.palette.background.paper",
    padding: "theme.spacing(0.25)",
    paddingLeft: "theme.spacing(0.5)",
    paddingRight: "theme.spacing(0.5)",
    flexGrow: 1,
  },
  row: {
    item: true,
    container: true,
    spacing: 1,
    justify: "center",
  },
  fab: {
    position: "fixed",
    bottom: "theme.spacing(2)",
    left: "theme.spacing(2)",
  },
  fabRow: {},
  fundSelectorRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  buttonRow: {
    margin: "10px",
    display: "flex",
    justifyContent: "space-around",
  },
};

export default function ComingSoon() {
  const classes = styles;

  return (
    <>
      {/* <CustomAppBar /> */}
      <Container maxWidth="xs">
        <div className={classes.mainContent}>
          <Grid
            container
            // spacing={1}
            justify="center"
            direction="column"
            style={{ marginTop: "10px" }}
          >
            <Typography>Coming soon!</Typography>
          </Grid>
        </div>
      </Container>
    </>
  );
}
